import { B1, SH2, Stack } from '@zet/design-system'
import LottieView from 'lottie-react-native'
import { ModalComponentProp } from 'react-native-modalfy'

import { DEVICE_WIDTH } from '@utils/Constants'

import { ModalStackParams } from '../modalConfig'

type Props = ModalComponentProp<ModalStackParams, void, 'ZetPrimePaymentModal'>
const ZetPrimePaymentModal = ({ modal: { closeModal, getParam } }: Props) => {
  const title = getParam('title') || 'Loading...'
  const subtitle = getParam('subTitle') || ''
  return (
    <Stack className="items-center justify-center flex-1 rounded-lg bg-white">
      <LottieView
        autoPlay
        resizeMode="cover"
        source={require('../../../../../packages/feature-zet-prime/assets/lottie/PaymentProcessing.json')}
        style={{ height: DEVICE_WIDTH * 0.6, width: 150, marginBottom: -54 }}
      />
      <SH2 className="text-tertiary-100 text-2xl mt-3">{title}</SH2>
      <B1 className="w-[50%] text-grays-80 text-center mt-3">{subtitle}</B1>
    </Stack>
  )
}

export default ZetPrimePaymentModal
